import React from "react";

const Withdrawdealfromwallet = () => {
  return <div>Withdrawdealfromwallet</div>;
};

export default Withdrawdealfromwallet;
